export class ThemePopup {
    static init() {
        var popup = document.querySelector('[data-theme-popup]');

        if (!popup) {
            return;
        }

        var cookieName = popup.dataset.cookieName || 'vosveteit_theme_popup';
        var hideDays = parseInt(popup.dataset.hideDays, 10);

        if (isNaN(hideDays) || hideDays < 1) {
            hideDays = 7;
        }

        if (ThemePopup.getCookie(cookieName)) {
            return;
        }

        var hasOpened = false;
        var scrollThreshold = window.innerHeight / 2;

        var onScroll = function () {
            if (hasOpened || window.scrollY < scrollThreshold) {
                return;
            }

            hasOpened = true;
            ThemePopup.open(popup);
            window.removeEventListener('scroll', onScroll);
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();

        ThemePopup.bindDismiss(popup, cookieName, hideDays);
    }

    /**
     * @param {HTMLElement} popup
     * @param {string} cookieName
     * @param {number} hideDays
     */
    static bindDismiss(popup, cookieName, hideDays) {
        var hide = function () {
            ThemePopup.setCookie(cookieName, '1', hideDays * 86400);
            ThemePopup.close(popup);
        };

        var ctaBtn = popup.querySelector('[data-theme-popup-cta]');
        var dismissBtn = popup.querySelector('[data-theme-popup-dismiss]');
        var closeBtn = popup.querySelector('[data-theme-popup-close]');

        if (ctaBtn) {
            ctaBtn.addEventListener('click', hide);
        }

        if (dismissBtn) {
            dismissBtn.addEventListener('click', hide);
        }

        if (closeBtn) {
            closeBtn.addEventListener('click', hide);
        }

        document.addEventListener('keydown', function (event) {
            if (event.key !== 'Escape' || popup.hasAttribute('hidden')) {
                return;
            }

            hide();
        });
    }

    /**
     * @param {string} name
     * @param {string} value
     * @param {number} maxAge
     */
    static setCookie(name, value, maxAge) {
        document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    }

    /**
     * @param {string} name
     * @returns {string|null}
     */
    static getCookie(name) {
        var escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        var match = document.cookie.match(new RegExp('(^| )' + escapedName + '=([^;]+)'));

        return match ? decodeURIComponent(match[2]) : null;
    }

    /**
     * @param {HTMLElement} popup
     */
    static open(popup) {
        popup.removeAttribute('hidden');
        document.body.classList.add('theme-popup-open');
    }

    /**
     * @param {HTMLElement} popup
     */
    static close(popup) {
        popup.setAttribute('hidden', 'hidden');
        document.body.classList.remove('theme-popup-open');
    }
}
